import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { MaterialPageGrid } from '../../../utils/material-page-grid';
import { ResearchPortalBdService } from '../../../services/research-portal-bd.service';

@Component({
  selector: 'app-sectors',
  templateUrl: './sectors.component.html',
  styleUrls: ['./sectors.component.scss'],
})
export class SectorsComponent implements OnInit {
  loadingData = false;
  sectorQuarterDates = [];
  dateSelector = new FormControl('');
  gridData = [];
  columns = [
    { id: 2, colOptional: true, label: 'Ticker', selected: true, field: 'ticker', type: '' },
    { id: 3, colOptional: true, label: 'Market Cap (BDT mn)', selected: true, field: 'marketCap', type: 'money' },
    { id: 4, colOptional: true, label: 'Cash (BDT mn)', selected: true, field: 'cash', type: 'number' },
    {
      id: 5,
      colOptional: true,
      label: 'Short-term Debt (BDT mn)',
      selected: true,
      field: 'shortTermDebt',
      type: 'number',
    },
    { id: 6, colOptional: true, label: 'Long-term Debt (BDT mn)', selected: true, field: 'longTermDebt', type: 'number' },
    { id: 7, colOptional: true, label: 'Debt (BDT mn)', selected: true, field: 'debt', type: 'number' },
    { id: 8, colOptional: true, label: 'Net Debt (BDT mn)', selected: true, field: 'netDebt', type: 'money' },
    { id: 9, colOptional: true, label: 'EV (BDT mn)', selected: true, field: 'ev', type: 'number' },
    { id: 10, colOptional: true, label: 'Total Equity (BDT mn)', selected: true, field: 'totalEquity', type: 'number' },
    { id: 11, colOptional: true, label: 'TTM Sales (BDT mn)', selected: true, field: 'ttmSales', type: 'number' },
    { id: 12, colOptional: true, label: 'Gross Profit (BDT mn)', selected: true, field: 'grossProfit', type: 'number' },
    { id: 13, colOptional: true, label: 'EBIT (BDT mn)', selected: true, field: 'ebit', type: 'number' },
    { id: 14, colOptional: true, label: 'PBT (BDT mn)', selected: true, field: 'pbt', type: 'money' },
    { id: 15, colOptional: true, label: 'Net Profit (BDT mn)', selected: true, field: 'netProfit', type: 'money' },
    { id: 16, colOptional: true, label: 'Effective Tax Rate (%)', selected: true, field: 'taxRate', type: 'money' },
  ];

  constructor(private researchPortalBd: ResearchPortalBdService, private cdRef: ChangeDetectorRef, private fb: FormBuilder) {}

  async ngOnInit() {
    this.loadingData = true;
    this.cdRef.detectChanges();
    let data = await this.researchPortalBd.getSectorQuarterDates();
    this.sectorQuarterDates = data;
    this.dateSelector.setValue(data[0]);
    await this.getSectorQuarterByDate();
    this.cdRef.detectChanges();
    this.dateSelector.valueChanges.subscribe(async () => {
      this.gridData = [];
      this.loadingData = true;
      this.cdRef.detectChanges();
      await this.getSectorQuarterByDate();
    });
  }

  async getSectorQuarterByDate() {
    let data = await this.researchPortalBd.getSectorData(this.dateSelector.value);
    await this.gridDataSettings(data);
  }

  async gridDataSettings(data) {
    this.gridData = [];
    this.cdRef.detectChanges();
    for (const sector of data) {
      let keys = Object.keys(sector.companies[0]);
      const filteredColumns = this.columns.filter((sec) => keys.find((k) => sec.field === k));
      const displayedColumns = filteredColumns.map((col) => col.field);
      const grid = new MaterialPageGrid(this.fb, 10)
        .setSource(async (query) => {
          // Simple local pagination for now
          const start = query.pageIndex * query.pageSize;
          const end = start + query.pageSize;
          const data = sector.companies.slice(start, end);
          return { data, total: sector.companies.length };
        })
        .setTableColumns(displayedColumns);
      const finalEachSectorData = {
        gridData: grid,
        gridName: sector.name,
        gridColumns: filteredColumns,
        displayedColumns: displayedColumns,
      };
      this.gridData.push(finalEachSectorData);
      this.cdRef.detectChanges();
    }
    this.loadingData = false;
    this.cdRef.detectChanges();
  }
}
